import classNamesOriginal from 'classnames';
import { twMerge } from 'tailwind-merge';
export var classNames = function classNames() {
  return twMerge(classNamesOriginal.apply(void 0, arguments));
};